import * as React from 'react';

const SvgPublicAlreadyDeny = (props) => (
  <svg
    width={178}
    height={119}
    viewBox="0 0 178 119"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M89.217 118.151C121.778 118.151 148.176 91.7531 148.176 59.0755C148.176 26.3979 121.662 0 89.217 0C56.6557 0 30.2578 26.3979 30.2578 59.0755C30.2578 91.7531 56.6557 118.151 89.217 118.151Z"
      fill="#CDD9F0"
    />
    <path
      d="M155.661 40.3581C158.294 40.3581 160.429 38.2234 160.429 35.5902C160.429 32.9569 158.294 30.8223 155.661 30.8223C153.028 30.8223 150.893 32.9569 150.893 35.5902C150.893 38.2234 153.028 40.3581 155.661 40.3581Z"
      fill="#CEE0FF"
    />
    <path
      d="M162.638 21.7518C164.437 21.7518 165.895 20.2939 165.895 18.4956C165.895 16.6973 164.437 15.2395 162.638 15.2395C160.84 15.2395 159.382 16.6973 159.382 18.4956C159.382 20.2939 160.84 21.7518 162.638 21.7518Z"
      fill="#CEE0FF"
    />
    <path
      d="M32.9329 20.3506C34.7312 20.3506 36.189 18.8928 36.189 17.0945C36.189 15.2962 34.7312 13.8384 32.9329 13.8384C31.1346 13.8384 29.6768 15.2962 29.6768 17.0945C29.6768 18.8928 31.1346 20.3506 32.9329 20.3506Z"
      fill="#CEE0FF"
    />
    <path
      d="M13.0471 83.1477C16.3868 83.1477 19.0942 80.4403 19.0942 77.1006C19.0942 73.7608 16.3868 71.0535 13.0471 71.0535C9.70738 71.0535 7 73.7608 7 77.1006C7 80.4403 9.70738 83.1477 13.0471 83.1477Z"
      fill="#CEE0FF"
    />
    <g filter="url(#filter0_d_2310_4090)">
      <path
        d="M151.563 75.4375H26.4375C24 75.4375 22 73.4375 22 71V40.4375C22 38 24 36 26.4375 36H151.563C153.999 36 156 38 156 40.4375V71C156 73.4375 153.999 75.4375 151.563 75.4375Z"
        fill="url(#paint0_linear_2310_4090)"
      />
    </g>
    <path
      d="M130.812 50.8123H61.1248C59.6247 50.8123 58.4373 49.9009 58.4373 48.7498C58.4373 47.5986 59.6247 46.6873 61.1248 46.6873H130.812C132.312 46.6873 133.5 47.5986 133.5 48.7498C133.5 49.9009 132.312 50.8123 130.812 50.8123Z"
      fill="#D6DCE8"
    />
    <path
      d="M105.812 63.3747H61.1248C59.6247 63.3747 58.4373 62.4634 58.4373 61.3123C58.4373 60.1611 59.6247 59.2498 61.1248 59.2498H105.812C107.312 59.2498 108.499 60.1611 108.499 61.3123C108.499 62.4634 107.312 63.3747 105.812 63.3747Z"
      fill="#D6DCE8"
    />
    <path
      d="M40.4994 66.8123C46.6436 66.8123 51.6245 61.8315 51.6245 55.6873C51.6245 49.5432 46.6436 44.5624 40.4994 44.5624C34.3553 44.5624 29.3745 49.5432 29.3745 55.6873C29.3745 61.8315 34.3553 66.8123 40.4994 66.8123Z"
      fill="url(#paint1_linear_2310_4090)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.8931 53.151L37.8932 60.0884L36.1072 58.2864L43.1072 51.3489L44.8931 53.151Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.8932 51.3489L44.8931 58.2864L43.1072 60.0884L36.1072 53.151L37.8932 51.3489Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_2310_4090"
        x={0}
        y={25}
        width={178}
        height={83.4375}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2310_4090"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2310_4090"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2310_4090"
        x1={78.8991}
        y1={40.1525}
        x2={81.1564}
        y2={73.7439}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2310_4090"
        x1={27.4504}
        y1={58.4766}
        x2={92.989}
        y2={-8.98221}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3E3E" />
        <stop offset={1} stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgPublicAlreadyDeny;
